import { render, staticRenderFns } from "./ToolbarNotifications.vue?vue&type=template&id=31eae6f7&"
import script from "./ToolbarNotifications.vue?vue&type=script&lang=js&"
export * from "./ToolbarNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports